<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="contain-section">
    <div class="row">
      <div class="col-sm-12 col-md-5 col-lg-4 col-xl-3">
        <div class="list-of-country align-start">
          <h3>Fatherline Distribution</h3>
          <br />
          <div class="">
            <ul class="father-active">
              <router-link
                :to="{
                  name: 'fatherline-distribution-map',
                  params: { region: d.id },
                }"
                v-for="d in fatherlineStore.result.distribution.map(
                  ({ title, percentage, id }) => ({
                    title,
                    percentage,
                    id,
                  })
                )"
                :key="d.id"
                class="flex justify-between no-underline px-4 py-1 rounded"
              >
                <li>
                  <button
                    @click="selectRegion(d.id)"
                    :class="
                      d.id === selectedRegion
                        ? 'selected-map-option'
                        : 'unselected-map-option'
                    "
                  >
                    <div class="custom-name">
                      <span>{{ d.percentage.toFixed(1) }}%</span>
                      <label>{{ d.title }}</label>
                    </div>
                  </button>
                </li></router-link
              >
            </ul>
          </div>
        </div>
      </div>

      <!-- Redirect to this section -->
      <div class="col-sm-12 col-md-7 col-lg-8 col-xl-9" id="comments-section">
        <div class="map-wrap">
          <div class="col-sm-12 mb-4">
            <div class="card-section">
              <h4 class="fs-3 text-black text-start fw-bolder mb-3">
                Fatherline Distribution Map
              </h4>
              <p class="text-start mb-1">
                You're viewing your distribution map which shows you where
                people who share your haplogroup live today.
              </p>
              <p class="text-start mb-0 mb-sm-3">
                Your distribution map shows you where in the world today people
                with your paternal haplogroup are living. The percentage
                represents the number of people in that region who share your
                haplotype.
              </p>
            </div>
          </div>
          <div class="col-sm-12">
            <DistributionMap
              v-if="showMap"
              v-model="selectedRegion"
              :coverage-data="stagedCoverageData"
              :gender="'fatherline'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <script>
import Header from "@/components/header/Header.vue";
import "../../../styles/pages/ancentry/recent-ancetry.scss";
export default {
    name: "AncestrySection",
    // Component logic
    components: {
        Header,
    },
};
</script> -->
<script setup>
import "../../../styles/pages/ancentry/recent-ancetry.scss";
import { useFatherlineStore } from "@/store/parentalStore";
// import Sidebar from "@/components/Sidebar.vue";
import { ref, onMounted, watchEffect } from "vue";
// import FeatherWrapper from "@/components/feather/FeatherWrapper.vue";
import DistributionMap from "@/components/ancestry/DistributionMap.vue";
// import MobileContent from "@/components/ancestry/MobileContent.vue";
import { useRoute } from "vue-router";
const loadingStatus = ref("loading");
const showMap = ref(false);
const stagedCoverageData = ref();
const route = useRoute();
const selectedRegion = ref(route.params.region || null);

setTimeout(() => {
  showMap.value = true;
}, 500);

// const route = useRoute();
const fatherlineStore = useFatherlineStore();

// const activeRegion = computed(() => {
//     return fatherlineStore.result.distribution.find((d) => d.id === route.params.region);
// });

onMounted(async () => {
  try {
    await fatherlineStore.getResult();
    if (!fatherlineStore.result) {
      throw new Error("No result");
    }
    console.log("Result fetched:", fatherlineStore.result);
    updateStagedCoverageData();
  } catch (error) {
    console.error(error);
  }
});

const selectRegion = (regionId) => {
  selectedRegion.value = regionId;
  updateStagedCoverageData();
  scrollToCommentsSection();
};

const scrollToCommentsSection = () => {
  const commentsSection = document.getElementById("comments-section");
  if (commentsSection) {
    commentsSection.scrollIntoView({ behavior: "smooth" });
  }
};

const updateStagedCoverageData = () => {
  if (fatherlineStore.result?.distribution) {
    stagedCoverageData.value = {
      type: "geojson",
      data: {
        id: "coverageMapData",
        type: "FeatureCollection",
        features: fatherlineStore.result.distribution
          .map(({ geoJson, ...properties }) => ({
            ...JSON.parse(geoJson),
            id: properties.id,
            properties,
          }))
          .filter((el) => el.geometry !== undefined),
      },
    };
    loadingStatus.value = "loaded";
    console.log("Staged coverage data updated:", stagedCoverageData.value);
  } else {
    console.error("No distribution data found in result.");
  }
};

// Watch for changes in motherlineStore.result and update stagedCoverageData accordingly
watchEffect(
  () => fatherlineStore.result,
  (newResult) => {
    if (newResult) {
      updateStagedCoverageData();
    }
  }
);
</script>
